import Repository from './Repository';

const resource = 'api/telemeter/basin';

export default {
  get({ pathParams, queryParams }:
    {
      pathParams: {
        target: 'dam' | 'gauge',
      },
      queryParams: {
        id: string,
        // eslint-disable-next-line camelcase
        date_time: string,
        hours: number,
        interval: string,
        raintype: string,
      }
    }): Promise<any> {
    return Repository.get(`${resource}/${pathParams.target}?id=${queryParams.id}&date_time=${queryParams.date_time}&hours=${queryParams.hours}&interval=${queryParams.interval}&raintype=${queryParams.raintype}`);
  },
};
